import React from 'react'
import { SponsorLogoBanner } from 'components'
import { LogoWithNoText } from 'assets'

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#3C2416] text-white py-6">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 mb-6">
          {/* Left Column - Logo and Info */}
          <div className="flex flex-row gap-6 pt-10">
            <div className="flex gap-2 items-start flex-col">
              <div className="flex gap-6 items-start">
                <img
                  src={LogoWithNoText}
                  alt="NASCC Logo"
                  className="w-24 flex-shrink-0"
                />
                <div className="max-w-[240px]">
                  <h3 className="font-semibold text-xl mb-1 leading-tight">
                    National Alliance of Sickle Cell Centers
                  </h3>
                  <p className="text-sm">
                    1129 20TH ST NW FL 4TH,
                    <br />
                    Washington, DC 20036
                  </p>
                </div>
              </div>
              <a
                href="mailto:support@sicklecellcenters.org"
                className="text-[#AF8A48] hover:underline text-sm"
              >
                support@sicklecellcenters.org
              </a>
            </div>
            <div className="space-y-2 text-sm">
              <a href="#" className="block hover:underline">
                Partners
              </a>
              <a href="#" className="block hover:underline">
                Member Logo Guidelines
              </a>
              <a href="#" className="block hover:underline">
                Job Postings
              </a>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div>
            <h3 className="text-lg font-medium ">
              Questions or comments? Send us a message below:
            </h3>
            <form className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <input
                    type="text"
                    placeholder="First name*"
                    className="w-full px-3 py-2 rounded bg-white text-[#3C2416] text-sm"
                    required
                  />
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Last name*"
                    className="w-full px-3 py-2 rounded bg-white text-[#3C2416] text-sm"
                    required
                  />
                </div>
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email address*"
                  className="w-full px-3 py-2 rounded bg-white text-[#3C2416] text-sm"
                  required
                />
              </div>
              <div>
                <textarea
                  placeholder="Type your message here ...."
                  rows={4}
                  className="w-full px-3 py-2 rounded bg-white text-[#3C2416] text-sm"
                  required
                />
              </div>
              <div className="text-right">
                <button
                  type="submit"
                  className="bg-[#A6410A] text-white px-6 py-2 rounded-full hover:bg-[#8A3608] transition-colors text-sm"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Sponsor Banner */}
        <SponsorLogoBanner className="bg-[#AF8A48] rounded-lg md:rounded-full" />
      </div>
    </footer>
  )
}
